import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'tfl-filter-business-type',
    template: `
        <div class="filter-business-type" [formGroup]="form" [ngClass]="{'no-matches': hasNoMatches()}">
            <div>
                <search-business-category-icon></search-business-category-icon>
            </div>
            <input [placeholder]="placeholder"
                   [name]="control"
                   class="form-control"
                   [formControlName]="control"
                   [id]="control"
                   (keyup)="searchEvent($event)"
                   (blur)="onBlur()"
            >
            <p *ngIf="hasRequiredError()"
               class="text-danger">
                {{'VALIDATION.REQUIRED'|translate}}
            </p>
            <p *ngIf="hasNoMatches()"
               class="text-danger">
                {{'VALIDATION.MATCHES_NOT_FOUND'|translate}}
            </p>
        </div>
    `
})
export class FilterBusinessTypes {

    private readonly MIN_LIST_SIZE = 'minListSize';
    private readonly MATCHES_NOT_FOUND = 'matchesNotFound';

    @Input('form') form: FormGroup;
    @Input('controlName') control: string;
    @Input('searchTimeOut') searchTimeOut: number;
    @Input('placeholder') placeholder: string;
    @Input('startSearchSymbolsCount') startSearchSymbolsCount = 3;
    @Output() search: EventEmitter<any> = new EventEmitter<any>();
    private tout;

    searchEvent(event) {
        clearTimeout(this.tout);
        if (event.target.value.length >= this.startSearchSymbolsCount) {
            this.tout = setTimeout(() =>
                    this.search.emit(event.target.value),
                this.searchTimeOut);
            return;
        }
        this.search.emit(undefined);
    }

    hasNoMatches(): boolean {
        let control = this.form.controls[this.control];
        return control.invalid && control.hasError(this.MATCHES_NOT_FOUND);
    }

    hasRequiredError(): boolean{
        let control = this.form.controls[this.control];
        return control.invalid && control.hasError(this.MIN_LIST_SIZE);
    }

    onBlur(){
        let control = this.form.controls[this.control];
        control.markAsUntouched();
        control.markAsPristine();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/filter/filter-business-types.component.ts